import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=6b9aa9f8&"
import script from "./Agenda.vue?vue&type=script&lang=js&"
export * from "./Agenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/tafelgasten/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b9aa9f8')) {
      api.createRecord('6b9aa9f8', component.options)
    } else {
      api.reload('6b9aa9f8', component.options)
    }
    module.hot.accept("./Agenda.vue?vue&type=template&id=6b9aa9f8&", function () {
      api.rerender('6b9aa9f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Boek/Agenda.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Boek/Agenda.vue
// module id = 341
// module chunks = 0